import { LinkIcon, AlertCircleIcon, Building2Icon, ArrowLeftIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { useAuthStore } from '@nebula/shared/store'

const CaptiveCustomerNoticePage = () => {
  const navigate = useNavigate()
  const { user } = useAuthStore()

  // Buscar informações do reseller pai (se disponível)
  const parentOrganization = user?.organization?.parent_name || 'seu reseller'

  return (
    <div className="flex min-h-screen items-center justify-center bg-linear-to-br from-gray-50 to-gray-100 p-4">
      <div className="w-full max-w-2xl rounded-2xl bg-white p-8 shadow-xl">
        {/* Header com ícone */}
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-blue-100 p-4">
            <LinkIcon className="size-12 text-blue-600" />
          </div>
        </div>

        {/* Título */}
        <h1 className="mb-4 text-center text-3xl font-bold text-gray-900">
          Você é um Cliente Cativo
        </h1>

        {/* Descrição */}
        <p className="mb-8 text-center text-gray-600">
          Sua organização está vinculada exclusivamente ao reseller{' '}
          <strong className="text-gray-900">{parentOrganization}</strong>.
        </p>

        {/* Info Box */}
        <div className="mb-8 rounded-lg border border-blue-200 bg-blue-50 p-6">
          <div className="flex">
            <AlertCircleIcon className="mt-0.5 size-6 shrink-0 text-blue-600" />
            <div className="ml-4">
              <h3 className="mb-3 font-semibold text-blue-900">O que isso significa?</h3>
              <ul className="space-y-2 text-sm text-blue-800">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Você tem acesso direto aos produtos e serviços do seu reseller</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Não precisa solicitar associações com outros resellers</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Seu suporte e atendimento é fornecido pelo reseller pai</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Preços e condições são negociados diretamente com o reseller</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Informação adicional */}
        <div className="mb-8 rounded-lg border border-gray-200 bg-gray-50 p-6">
          <div className="flex items-start">
            <Building2Icon className="mt-0.5 size-5 shrink-0 text-gray-500" />
            <div className="ml-3">
              <h4 className="mb-2 font-medium text-gray-900">Funcionalidades disponíveis</h4>
              <p className="mb-3 text-sm text-gray-600">
                Como cliente cativo, você tem acesso a todas as funcionalidades principais da
                plataforma:
              </p>
              <div className="grid grid-cols-2 gap-2 text-sm text-gray-700">
                <div>✓ Marketplace de Produtos</div>
                <div>✓ Gerenciamento de VMs</div>
                <div>✓ Monitoramento</div>
                <div>✓ Backups</div>
                <div>✓ Cobrança e Créditos</div>
                <div>✓ Suporte</div>
              </div>
            </div>
          </div>
        </div>

        {/* Nota sobre marketplace */}
        <div className="mb-8 rounded-lg border border-yellow-200 bg-yellow-50 p-4">
          <div className="flex">
            <AlertCircleIcon className="mt-0.5 size-5 shrink-0 text-yellow-600" />
            <div className="ml-3">
              <p className="text-sm text-yellow-800">
                <strong>Nota:</strong> As funcionalidades de "Marketplace de Resellers" e "Minhas
                Associações" não estão disponíveis para clientes cativos, pois você já possui um
                relacionamento estabelecido com {parentOrganization}.
              </p>
            </div>
          </div>
        </div>

        {/* Botão de voltar */}
        <div className="flex justify-center">
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center space-x-2 rounded-lg bg-blue-600 px-6 py-3 text-white transition-colors hover:bg-blue-700"
          >
            <ArrowLeftIcon className="size-5" />
            <span>Voltar ao Dashboard</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default CaptiveCustomerNoticePage
